export default "* Fisk\n* Gæller\n* Camouflage\n* Føde\n* Svømmeblære\n* Gat";